import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { phaseChange, reroute, storeDumpItForce } from '../../../actions/Buy'
import { getOrdineAfterRestore } from '../../../actions/buy/Ordini'
import {
  getServiziAggiuntiviV1,
  normalizeSelectedServiziAggiuntivi,
  putOrdiniServiziAggiuntiviV1,
  setSelectedServizioAggiuntivo,
  unSetAllServiziAggiuntivi,
  unSetSelectedServizioAggiuntivo,
} from '../../../actions/buy/ServiziAggiuntivi'
import { errorNotice } from '../../../actions/ErrorNotice'
import { VAS } from '../../../constants/vas'
import { VasSettingsHelper } from '../../../helpers/vas/settings'
import { EnhancedEcommerceMapper } from '../../../tracking/EnhancedEcommerce/mapper'
import { enhancedEcommerceTracker } from '../../../tracking/EnhancedEcommerce/tracker'
import PromptModal from '../../common/PromptModal'
import {
  CRITEO_EVENTS,
  EVENT_TYPES,
  triggerClickStreamEvent,
} from '../../triggerDataLayerEvent'
import BuyButton from '../dumb/BuyButton'
import BuyCheckboxInput from '../dumb/BuyCheckboxInput'
import BuyMiniCart from '../dumb/BuyMiniCart'
import VasPolishingModal from '../dumb/modals/VasPolishingModal'
import { preparaValoriLogistica } from '../utils'

class ServiziAggiuntiviUsato extends Component {
  constructor(props) {
    super(props)
    this.state = {
      canContinue: false,
      showConfirmModal: false,
      showVasPolishingModal: false,
      isEECTracked: false,
    }

    this.handleSelezionaServizioAggiuntivo =
      this.handleSelezionaServizioAggiuntivo.bind(this)
    this.buildServizioAggiuntivoPriceComponent =
      this.buildServizioAggiuntivoPriceComponent.bind(this)
    this.getServizioAggiuntivoChecked =
      this.getServizioAggiuntivoChecked.bind(this)
    this.hasServiziAggiuntiviSelected =
      this.hasServiziAggiuntiviSelected.bind(this)

    const promptErrorModal = (title, description) =>
      this.props.errorNotice({
        logo: 'dati_non_corretti',
        message:
          description || "E' necessario selezionare almeno un'assicurazione",
        title: title || 'Selezione non corretta',
        type: 'custom',
      })

    this.setDefaultChecked = this.setDefaultChecked.bind(this)

    this.state.vasSettingsHelper = new VasSettingsHelper(
      props.ui.sellout_settings_acquista &&
        props.ui.sellout_settings_acquista.vas_settings,
      promptErrorModal
    )
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  async componentDidMount() {
    this.props.phaseChange({ phase: 15 })

    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')

      return
    }

    const res = await this.props.getOrdineAfterRestore()
    if (res && res.result) {
      this.props.storeDumpItForce()
      await this.props.getServiziAggiuntiviV1()
      await this.props.normalizeSelectedServiziAggiuntivi()
      await this.setDefaultChecked()

      this.preselectSecurityKitVas() // todo : remove this hardcoded snippet, when preselected vas are dynamically configurable
    }

    if (!this.state.isEECTracked) {
      this.setState(
        {
          isEECTracked: true,
        },
        () =>
          enhancedEcommerceTracker
            .pushCheckout(
              {
                product: this.props.product,
                ordine: this.props.ordine,
              },
              2
            )
            .then(() => {})
      )
    }
  }

  preselectSecurityKitVas() {
    const securityKitVas =
      this.props.ordine.servizi_aggiuntivi_disponibili.find(
        vas => VAS.SECURITY_KIT.id_vas === vas.id_vas
      )
    if (!this.getServizioAggiuntivoChecked(securityKitVas)) {
      this.props.setSelectedServizioAggiuntivo(securityKitVas)
    }
  }

  handleInvalidChoices() {
    this.state.vasSettingsHelper.errors.raise()
  }

  setDefaultChecked() {
    const fn = async item =>
      await this.props.setSelectedServizioAggiuntivo(item)

    return this.state.vasSettingsHelper.setDefaultChecked(
      this.props.ordine.servizi_aggiuntivi_disponibili,
      fn
    )
  }

  hasSettingsCoupon() {
    return (
      this.props.ui.sellout_settings_acquista &&
      this.props.ui.sellout_settings_acquista.vas_settings
    )
  }

  handleSelezionaServizioAggiuntivo(servizio_aggiuntivo) {
    const t = this
    return event => {
      const { checked } = event.target

      if (!this.hasSettingsCoupon()) {
        checked
          ? t.props.setSelectedServizioAggiuntivo(servizio_aggiuntivo)
          : t.props.unSetSelectedServizioAggiuntivo(servizio_aggiuntivo)

        if (checked) {
          this.clearIncompatibles(servizio_aggiuntivo)
        }

        return
      }

      const choices = JSON.parse(
        JSON.stringify(this.props.ordine.servizi_extra.ordini_servizi || [])
      )

      const vasIndex = choices.findIndex(
        item => item.id_servizio === servizio_aggiuntivo.id_servizio
      )

      if (checked && vasIndex !== -1) {
        return
      }

      checked ? choices.push(servizio_aggiuntivo) : choices.splice(vasIndex, 1)

      const isValid = this.state.vasSettingsHelper.isValid(choices)
      if (!isValid) {
        this.handleInvalidChoices()

        return
      }

      checked
        ? t.props.setSelectedServizioAggiuntivo(servizio_aggiuntivo)
        : t.props.unSetSelectedServizioAggiuntivo(servizio_aggiuntivo)

      if (checked) {
        this.clearIncompatibles(servizio_aggiuntivo)
      }
    }
  }

  clearIncompatibles(servizio_aggiuntivo) {
    if (!this.props.ordine?.servizi_extra?.ordini_servizi) {
      return
    }
    for (const selectedVas of this.props.ordine.servizi_extra.ordini_servizi) {
      if (
        servizio_aggiuntivo.id_vas === selectedVas.id_vas ||
        servizio_aggiuntivo.id_dominio !== selectedVas.id_dominio
      ) {
        continue
      }

      this.props.unSetSelectedServizioAggiuntivo(selectedVas)
    }
  }

  getServizioAggiuntivoChecked(servizio_aggiuntivo) {
    if (
      !this.props.ordine.servizi_extra.ordini_servizi ||
      !this.props.ordine.servizi_extra.ordini_servizi.length
    ) {
      return false
    }

    return this.props.ordine.servizi_extra.ordini_servizi.find(
      element => element.id_servizio === servizio_aggiuntivo.id_servizio
    )
  }

  buildServizioAggiuntivoPriceComponent(servizioAggiuntivo) {
    if (servizioAggiuntivo.prezzo_listino === 0) {
      // gratis
      return <b className="yellow">Incluso</b>
    }
    if (servizioAggiuntivo.prezzo < servizioAggiuntivo.prezzo_listino) {
      // in promozione
      return (
        <div className="vas-price-promo">
          <b className="vas-price-promo-original-price-container">
            <span className="vas-price-promo-label">In promozione</span>
            <span className="vas-price-promo-original-price">
              + € {servizioAggiuntivo.prezzo_listino}
            </span>
          </b>
          <b className="vas-price-promo-current-price">
            + € {servizioAggiuntivo.prezzo}
          </b>
        </div>
      )
    }
    // si paga
    return <b>+ € {servizioAggiuntivo.prezzo}</b>
  }

  handleProsegui = async () => {
    await this.props.putOrdiniServiziAggiuntiviV1()

    enhancedEcommerceTracker
      .pushCheckoutOption(
        2,
        EnhancedEcommerceMapper.mapSelectedVas({
          ordine: this.props.ordine,
          product: this.props.product,
        })
      )
      .then(() => {})

    this.props.reroute('/checkout')
  }

  hasServiziAggiuntiviSelected() {
    return (
      this.props.ordine.servizi_extra.ordini_servizi &&
      this.props.ordine.servizi_extra.ordini_servizi.length
    )
  }

  onUpdate(value) {
    this.setState({ showConfirmModal: false })

    if (value) {
      if (this.hasSettingsCoupon()) {
        this.props.ordine.servizi_aggiuntivi_disponibili.map(
          // eslint-disable-next-line
          servizioAggiuntivo => {
            if (
              !this.state.vasSettingsHelper.isDefaultChecked(servizioAggiuntivo)
            ) {
              this.props.unSetSelectedServizioAggiuntivo(servizioAggiuntivo)
            }
          }
        )
      } else {
        this.props.unSetAllServiziAggiuntivi()
      }

      this.setState({ canContinue: true })
    }
  }

  render() {
    return (
      <section className="relative process serviziAggiuntivi">
        <div className="process__header">
          <h1 className="process__title">
            Scegli i servizi aggiuntivi che preferisci
          </h1>
        </div>
        <div className="user-informations">
          <div className="container_small">
            <div className="process__column process__column__left">
              {this.props.ordine.domini_servizi_aggiuntivi_disponibili
                .length ? (
                <div className="process__column process__column__center colonna_due">
                  <h5 className="section-title --reduced">
                    Vuoi aggiungere servizi plus?
                  </h5>
                  <div className="box-elementi">
                    {this.props.ordine.domini_servizi_aggiuntivi_disponibili.map(
                      domain => {
                        const services =
                          this.props.ordine.servizi_aggiuntivi_disponibili.filter(
                            service => service.id_dominio === domain.id
                          )

                        return (
                          <div className="box-domain" key={domain.titolo}>
                            <h6 className="box-domain-title">
                              {domain.titolo}
                            </h6>

                            {services.map(servizioAggiuntivo => {
                              const isHiddenByCoupon =
                                this.state.vasSettingsHelper.isHidden({
                                  id_servizio: servizioAggiuntivo.id_servizio,
                                })

                              if (isHiddenByCoupon) {
                                return
                              }

                              const label = (
                                <div
                                  className={`service-box-label ${
                                    !servizioAggiuntivo.prezzo_listino
                                      ? `service-box-label--included`
                                      : ``
                                  }`}
                                  key={`${servizioAggiuntivo.id_servizio}_inner`}
                                >
                                  <div className={`box-left`}>
                                    <h6>{servizioAggiuntivo.titolo}</h6>
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: servizioAggiuntivo.descrizione,
                                      }}
                                    />
                                  </div>
                                  <div className={'box-right'}>
                                    {this.buildServizioAggiuntivoPriceComponent(
                                      servizioAggiuntivo
                                    )}
                                  </div>
                                </div>
                              )

                              return (
                                <div
                                  className="box-option-row"
                                  key={servizioAggiuntivo.id_servizio}
                                >
                                  {servizioAggiuntivo.prezzo_listino > 0 ? (
                                    <BuyCheckboxInput
                                      checked={
                                        !!this.getServizioAggiuntivoChecked(
                                          servizioAggiuntivo
                                        )
                                      }
                                      classes={`r-checkbox long`}
                                      dataCy={`vas-service`}
                                      disabled={this.state.vasSettingsHelper.isDisabled(
                                        servizioAggiuntivo
                                      )}
                                      label={[label]}
                                      update={this.handleSelezionaServizioAggiuntivo(
                                        servizioAggiuntivo
                                      )}
                                      value={this.getServizioAggiuntivoChecked(
                                        servizioAggiuntivo
                                      )}
                                    />
                                  ) : (
                                    label
                                  )}
                                  {servizioAggiuntivo.id_vas ===
                                    VAS.POLISHING.id_vas && (
                                    <p
                                      className="box-option-link"
                                      onClick={() =>
                                        this.setState({
                                          showVasPolishingModal: true,
                                        })
                                      }
                                    >
                                      Guarda l'auto prima e dopo il trattamento
                                    </p>
                                  )}
                                </div>
                              )
                            })}
                          </div>
                        )
                      }
                    )}

                    <PromptModal
                      dataCyNo="vas-no-services-prompt-no"
                      dataCyYes="vas-no-services-prompt-yes"
                      display={this.state.showConfirmModal}
                      onClose={value => {
                        this.onUpdate(value)
                      }}
                      onUpdate={value => {
                        this.onUpdate(value)
                      }}
                    >
                      <React.Fragment>
                        <h4 className="modal-title">
                          Vuoi rimuovere i servizi aggiuntivi che hai
                          selezionato?
                        </h4>
                        <p
                          className="text-center"
                          style={{ width: '85%', margin: '0 auto' }}
                        >
                          Selezionando il pulsante “Sì” verranno rimossi i
                          servizi che hai scelto.
                        </p>
                      </React.Fragment>
                    </PromptModal>

                    <VasPolishingModal
                      modalTitle="Lucidatura"
                      onClose={() => {
                        this.setState({
                          showVasPolishingModal: false,
                        })
                      }}
                      show={this.state.showVasPolishingModal}
                    />

                    {this.state.vasSettingsHelper &&
                    (this.state.vasSettingsHelper.isRequired ||
                      this.state.vasSettingsHelper
                        .isMandatoryChecked) ? null : (
                      <div className="box-domain">
                        <BuyCheckboxInput
                          checked={
                            !this.hasServiziAggiuntiviSelected()
                              ? this.state.canContinue
                              : false
                          }
                          classes={'r-checkbox r-checkbox--empty long'}
                          dataCy={'vas-no-services'}
                          label={[
                            <div className="service-box-label">
                              <div className="box-left">
                                <h6>Nessun servizio aggiuntivo</h6>
                              </div>
                            </div>,
                          ]}
                          update={event => {
                            if (event.target.checked) {
                              if (this.hasServiziAggiuntiviSelected()) {
                                this.setState({ showConfirmModal: true })
                              } else {
                                this.setState({ canContinue: true })
                              }
                            }
                          }}
                          value={
                            !this.hasServiziAggiuntiviSelected()
                              ? this.state.canContinue
                              : false
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
              <div className="space-20"></div>
              <p className="text-center hide-mobile">
                <BuyButton
                  classes={`btn btn-primary${
                    this.props.fetching ||
                    (!this.hasServiziAggiuntiviSelected() &&
                      !this.state.canContinue)
                      ? ' btn-disabled'
                      : ''
                  }`}
                  dataCy={'vas-submit'}
                  disabled={
                    !this.hasServiziAggiuntiviSelected() &&
                    !this.state.canContinue
                  }
                  label={'Prosegui'}
                  update={() => {
                    if (
                      !this.hasServiziAggiuntiviSelected() &&
                      !this.state.canContinue
                    ) {
                      return false
                    }

                    this.handleProsegui().then(() => {
                      triggerClickStreamEvent(
                        CRITEO_EVENTS.BASKET_FUNNEL_CHECKOUT,
                        EVENT_TYPES.CRITEO,
                        {
                          email: this.props.customer.email,
                          idAuto: this.props.product.id_auto,
                          price: numeral(
                            this.props.ordine.totale - this.props.ordine.acconti
                          ).format('$ 0,0[.]00'),
                        }
                      )
                    })
                  }}
                />
              </p>
            </div>
            <div className="process__column process__column__right">
              <BuyMiniCart
                {...preparaValoriLogistica(
                  this.props.pricing.total,
                  this.props.logistica
                )}
                acconti={this.props.ordine.acconti}
                agevolazione_iva_104={this.props.customer.agevolazione_iva_104}
                finanziamento={null}
                idAuto={this.props.product.id_auto}
                km={this.props.product.km}
                ordine={this.props.ordine}
                ownership={
                  this.props.product.passaggio_proprieta_totale_generale
                }
                paymentMethod={null}
                price={this.props.ordine.auto_prezzo_sellout}
                product={this.props.product}
                sconto={this.props.ordine.sconto}
                totalone={this.props.ordine.totale}
                year={this.props.product.anno}
              />

              <p className="text-center hide-desktop">
                <BuyButton
                  classes={`btn btn-primary${
                    this.props.fetching ||
                    (!this.hasServiziAggiuntiviSelected() &&
                      !this.state.canContinue)
                      ? ' btn-disabled'
                      : ''
                  }`}
                  disabled={
                    !this.hasServiziAggiuntiviSelected() &&
                    !this.state.canContinue
                  }
                  label={'Prosegui'}
                  update={() => {
                    if (
                      !this.hasServiziAggiuntiviSelected() &&
                      !this.state.canContinue
                    ) {
                      return false
                    }

                    this.handleProsegui().then(() => {
                      triggerClickStreamEvent(
                        CRITEO_EVENTS.BASKET_FUNNEL_CHECKOUT,
                        EVENT_TYPES.CRITEO,
                        {
                          email: this.props.customer.email,
                          idAuto: this.props.product.id_auto,
                          price: numeral(
                            this.props.ordine.totale - this.props.ordine.acconti
                          ).format('$ 0,0[.]00'),
                        }
                      )
                    })
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

ServiziAggiuntiviUsato.propTypes = {
  customer: PropTypes.object,
  phaseChange: PropTypes.func,
  product: PropTypes.object,
  reroute: PropTypes.func,
  storeDumpItForce: PropTypes.func,
  pricing: PropTypes.object,
  logistica: PropTypes.object,
  ordine: PropTypes.object,
  ui: PropTypes.object,
  normalizeSelectedServiziAggiuntivi: PropTypes.func,
  setSelectedServizioAggiuntivo: PropTypes.func,
  unSetSelectedServizioAggiuntivo: PropTypes.func,
  unSetAllServiziAggiuntivi: PropTypes.func,
  putOrdiniServiziAggiuntiviV1: PropTypes.func,
}

const mapStateToProps = state => ({
  customer: state.customer,
  product: state.product,
  order: state.order,
  pricing: state.pricing,
  logistica: state.logistica,
  ordine: state.ordine,
  ui: state.ui,
})

const mapDispatchToProps = dispatch => ({
  phaseChange: phase => dispatch(phaseChange(phase)),
  reroute: rerouteTo => dispatch(reroute(rerouteTo)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  getOrdineAfterRestore: () => dispatch(getOrdineAfterRestore),
  getServiziAggiuntiviV1: () => dispatch(getServiziAggiuntiviV1),
  normalizeSelectedServiziAggiuntivi: payload =>
    dispatch(normalizeSelectedServiziAggiuntivi(payload)),
  setSelectedServizioAggiuntivo: payload =>
    dispatch(setSelectedServizioAggiuntivo(payload)),
  unSetSelectedServizioAggiuntivo: payload =>
    dispatch(unSetSelectedServizioAggiuntivo(payload)),
  unSetAllServiziAggiuntivi: payload =>
    dispatch(unSetAllServiziAggiuntivi(payload)),
  putOrdiniServiziAggiuntiviV1: () => dispatch(putOrdiniServiziAggiuntiviV1),
  errorNotice: payload => dispatch(errorNotice(payload)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiziAggiuntiviUsato)
